import React from "react";
import { Box } from "@mui/material";
import CustomTypography from "../form/CustomTypography";

interface GradientDividerProps {
  title: string;
  color?: string;
  sx?: object;
}

const GradientDivider: React.FC<GradientDividerProps> = ({
  title,
  color = "128,0,255",
  sx,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        my: 3,
        ...sx,
      }}
    >
      <Box
        sx={{
          flex: 1,
          height: "1px",
          background: `linear-gradient(to right, rgba(${color},0.5), rgba(${color},0.10))`,
        }}
      />

      <CustomTypography variant="heading8">{title}</CustomTypography>

      <Box
        sx={{
          flex: 1,
          height: "1px",
          background: `linear-gradient(to left, rgba(${color},0.5), rgba(${color},0.10))`,
        }}
      />
    </Box>
  );
};

export default GradientDivider;
